$(document).ready(function() {
    /* AUSSEERLAND */
    $('#ttgNaviKarte_ausseerland-salzkammergut').attr("target", "_blank");
    $('#ttgNaviKarte_ausseerland-salzkammergut').attr("onclick", "return iapixel('9383630333236323131303',  'do', '3', {custom1:'Verlinkung Ausseerland'})");

    /* DACHSTEIN-SALZKAMMERGUT */
    $('#ttgNaviKarte_dachstein-salzkammergut').attr("target", "_blank");
    $('#ttgNaviKarte_dachstein-salzkammergut').attr("onclick", "return iapixel('9383630333236323131303',  'do', '3', {custom1:'Verlinkung Dachstein-Salzkammergut'})");

    /* WOLFGANGSEE */
    $('#ttgNaviKarte_wolfgangsee').attr("target", "_blank");
    $('#ttgNaviKarte_wolfgangsee').attr("onclick", "return iapixel('9383630333236323131303',  'do', '3', {custom1:'Verlinkung Wolfgangsee'})");

    /* TRAUNSEE */
    $('#ttgNaviKarte_traunsee').attr("target", "_blank");
    $('#ttgNaviKarte_traunsee').attr("onclick", "return iapixel('9383630333236323131303',  'do', '3', {custom1:'Verlinkung Traunsee'})");

    /* ATTERSEE */
    $('#ttgNaviKarte_attersee').attr("target", "_blank");
    $('#ttgNaviKarte_attersee').attr("onclick", "return iapixel('9383630333236323131303',  'do', '3', {custom1:'Verlinkung Attersee'})");

    /* BAD ISCHL */
    $('#ttgNaviKarte_bad-ischl').attr("target", "_blank");
    $('#ttgNaviKarte_bad-ischl').attr("onclick", "return iapixel('9383630333236323131303',  'do', '3', {custom1:'Verlinkung Bad Ischl'})");

    /* MONDSEE */
    $('#ttgNaviKarte_mondsee---irrsee').attr("target", "_blank");
    $('#ttgNaviKarte_mondsee---irrsee').attr("onclick", "return iapixel('9383630333236323131303',  'do', '3', {custom1:'Verlinkung Mondsee'})");

    /* FUSCHLSEE */
    $('#ttgNaviKarte_fuschlseeregion').attr("target", "_blank");
    $('#ttgNaviKarte_fuschlseeregion').attr("onclick", "return iapixel('9383630333236323131303',  'do', '3', {custom1:'Verlinkung Fuschlseeregion'})");

    /* ALMTAL */
    $('#ttgNaviKarte_almtal').attr("target", "_blank");
    $('#ttgNaviKarte_almtal').attr("onclick", "return iapixel('9383630333236323131303',  'do', '3', {custom1:'Verlinkung Almtal'})");

    /* ATTERGAU */
    $('#ttgNaviKarte_attergau').attr("target", "_blank");
    $('#ttgNaviKarte_attergau').attr("onclick", "return iapixel('9383630333236323131303',  'do', '3', {custom1:'Verlinkung Attergau'})");
});


/**
 * Send click pixel
 *
 * Valid conversion types:
 * - 'sa' for sale
 * - 'le' for lead
 * - 'si' for signup
 * - 'pa' for pageview
 * - 'do' for download
 *
 * Note: Links should always open in a new window (target=_blank)
 *
 * @param integer  cId     Client ID [mandatory]
 * @param string   cvType  Conversion Type (i.e. 'le', 'sa', 'do', 'si')  [mandatory]
 * @param float    cvValue Conversion Value (i.e. '2.5') [mandatory]
 * @param object   opts    Additional Info [optional] Refer to manual for valid options and parameters
 */
function iapixel(cId, cvType, cvValue, opts) {
    if (cId && cvType && cvValue) {
        var merge = function(d, s) {
            for (var p in s) {
                if (d.hasOwnProperty(p)) {
                    d[p] = s[p];
                }
            }
            return d;
        };
        var options = merge({
            currency: 'EUR', // conversion currency code(ACCORDING ISO 4271 i.e. 'EUR' or 'USD') [optional]
            orderId: '', // orderId [optional]
            custom1: '', // custom value 1 [optional]
            custom2: '', // custom value 2 [optional]
            custom3: '', // custom value 3 [optional]
            custom4: '' // custom value 4 [optional]
        }, opts || {});
        var varMap = {
            currency: 'vv',
            orderId: 'po',
            custom1: 'c1',
            custom2: 'c2',
            custom3: 'c3',
            custom4: 'c4'
        };
        var proto = (document.location.toString().indexOf('https://') != -1) ? 'https' : 'http';
        var uri = 't23.intelliad.de/tc.php';
        var url = '?cl=' + encodeURIComponent(cId) + '&v=' + encodeURIComponent(cvValue) + '&vz=' + encodeURIComponent(cvType) + '&';
        for (var v in varMap) {
            if (varMap.hasOwnProperty(v)) {
                url += varMap[v] + '=' + encodeURIComponent(options[v]) + '&';
            }
        }
        var imgsrc = proto + '://' + uri + url + '&rand=' + Math.floor(Math.random() * 11111139435231);
        var img = new Image();
        img.setAttribute('width', 1);
        img.setAttribute('height', 1);
        img.src = imgsrc;
        document.getElementsByTagName('body')[0].appendChild(img);
    }
    return true;
}